/**
 * Singleton that manages the list hub activity
 */
define(['jquery', 'listhub', 'jquerycookie'], function ($) {
   "use strict";

   var m_channel = "M-2245";
   var m_channel_ren = "M-1570";
   
   //var m_gachannel = "M-1499";
   //var m_gachannel_ren = "M-1559";

   function trackFailed () {
      if (!window._listhub_tracker) {
         require(['c21'], function (c21) {
            c21.debug('Could not track. ListHub did not load.');
         });
         return true;
      }

      return false;
   }

   /**
    * Track listings by key
    */
   function doTracking(listingkey, type) {
      if (trackFailed()) return;

      // Check the switch for list hub
      if (window.disableListHubTracking === true) {
         return;
      }

      // Only do this for a REN listing
      if (listingkey !== null && listingkey.indexOf("3yd") === 0) {
         window._listhub_tracker(listingkey, m_channel_ren, type, $.cookie('ref_code'));
         return;
      }

      // Only do this for C21 listings - [CEN-5340 DEPRECATED]
      /*
      if (listingkey.indexOf("BHG") < 0 && listingkey.indexOf("CBR") < 0 && listingkey.indexOf("ERA") < 0 && listingkey.indexOf("LCE") < 0) {
         listingkey = listingkey.replace("C21", "");
         window._listhub_tracker(listingkey, m_channel, type, $.cookie('ref_code'));
      }*/
   }
   
   /**
    * Track C21 listings by GUID
    */
   function doTrackingC21(listingGUID, type) {
      if (trackFailed()) return;

      // Check the switch for list hub
      if (window.disableListHubTracking === true) {
         return;
      }
      listingGUID = listingGUID.toUpperCase();
      //window._listhub_tracker(listingGUID, m_channel, type, $.cookie('ref_code'));
   }

   var self = {
         doTracking : doTracking,
         doTrackingC21: doTrackingC21
      };

   // Inline tracking URLs
   window.listHub = self;

   return self;
});
